import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {ReactSortable} from 'react-sortablejs';
/* Components */
import Accordion from '../../common/accordion/accordion';
import DashboardItem from '../dashboard-item/dashboard-item';
// Helpers
import {getCloneName} from '../../../helpers/clone';
/* styles */
import './dashboard-library-accordion.scss';
import {reorderFavoriteDashboards} from '../../../store/dashboard/dashboard-actions';

class DashboardLibraryAccordion extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      favoritesOrder: props.items,
    };
  }

  getDashboardCloneName = (dashboardName) => getCloneName(dashboardName, this.props.items);

  handleReorder = () => {
    this.props.reorderFavoriteDashboards(this.state.favoritesOrder);
  };

  setFavoritesOrder = (dashboards) => {
    this.setState({
      favoritesOrder: dashboards,
    });
  };

  getSortableAccordion = () => {
    return (
      <>
        {this.props.items.length === 0 ? (
          <div className="glu-content__section glu-flex glu-flex-align-center">
            <span className="g-icon g-icon-info" />
            <p className="glu-dashboard-library__empty">
              All of your dashboards are set as {this.props.infoTitle}
            </p>
          </div>
        ) : (
          <ReactSortable
            className="dashboard-library__items glu-flex glu-flex-row glu-row--fluid"
            group="columnsGroup"
            list={this.state.favoritesOrder}
            setList={this.setFavoritesOrder}
            onEnd={this.handleReorder}
            animation={300}
            delay={0}
          >
            {this.props.items.map((dashboard) => (
              <DashboardItem
                key={dashboard.id}
                dashboard={dashboard}
                toggleDashboardModal={this.props.toggleDashboardModal}
                handleDashboardInfoClick={this.props.handleDashboardInfoClick}
                openDashboardPage={this.props.openDashboardPage}
                history={this.props.history}
                getImage={this.props.getImage}
                getDashboardCloneName={this.getDashboardCloneName}
                layout={this.props.dashboardLayout}
              />
            ))}
          </ReactSortable>
        )}
      </>
    );
  };

  getNonSortableAccordion = () => {
    return (
      <div className="dashboard-library__items glu-flex glu-flex-row glu-row--fluid">
        {this.props.items.length === 0 ? (
          <div className="glu-content__section glu-flex glu-flex-align-center">
            <span className="g-icon g-icon-info" />
            <p className="glu-dashboard-library__empty">
              All of your dashboards are set as {this.props.infoTitle}
            </p>
          </div>
        ) : (
          this.props.items.map((dashboard) => (
            <DashboardItem
              key={dashboard.id}
              dashboard={dashboard}
              toggleDashboardModal={this.props.toggleDashboardModal}
              handleDashboardInfoClick={this.props.handleDashboardInfoClick}
              openDashboardPage={this.props.openDashboardPage}
              history={this.props.history}
              getImage={this.props.getImage}
              getDashboardCloneName={this.getDashboardCloneName}
              layout={this.props.dashboardLayout}
            />
          ))
        )}
      </div>
    );
  };

  render() {
    return (
      <Accordion
        title={this.props.title}
        isOpened={this.props.accordionOpened}
        toggleAccordion={this.props.toggleAccordion}
      >
        {this.props.reorderingAllowed
          ? this.getSortableAccordion()
          : this.getNonSortableAccordion()}
      </Accordion>
    );
  }
}

DashboardLibraryAccordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  openDashboardPage: PropTypes.func.isRequired,
  handleDashboardInfoClick: PropTypes.func.isRequired,
  toggleDashboardModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  infoTitle: PropTypes.string.isRequired,
  getImage: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  dashboardLayout: PropTypes.string.isRequired,
  reorderingAllowed: PropTypes.bool,
  reorderFavoriteDashboards: PropTypes.func.isRequired,
  accordionOpened: PropTypes.bool,
  toggleAccordion: PropTypes.func.isRequired,
  isHelpIntroDisabled: PropTypes.bool,
};

DashboardLibraryAccordion.defaultProps = {
  reorderingAllowed: false,
  accordionOpened: true,
  isHelpIntroDisabled: false,
};

const mapStateToProps = ({
  userReducer: {dashboardLayout},
  tooltipsReducer: {isHelpIntroDisabled},
}) => {
  return {
    dashboardLayout,
    isHelpIntroDisabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reorderFavoriteDashboards: (dashboards) => reorderFavoriteDashboards(dispatch, dashboards),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLibraryAccordion);
